import styled from "styled-components";
export const Styles = styled.div`
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.7);
  padding: 15px;
  border-radius: 7px;
  width: 100%;
  cursor: pointer;
  transition: all.3s;
  &:hover {
    transform: translateY(-3px);
  }
  .title-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 15px;
    .title {
      font-weight: 600;
      width: calc(100% - 100px);
      text-align: start;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .rate {
      width: 80px;
    }
  }
  .description {
    width: 100%;
    text-align: start;
    margin-bottom: 5px;
  }
  .inner-container {
    display: flex;
    justify-content: space-between;
    .data.end {
      .description {
        text-align: end;
      }
    }
  }
`;
